export default __webpack_public_path__ + "static/media/image-28.e3a7264b.png";